import React, { useState, useEffect } from 'react';
import { Grid, Button, Table, Typography, TextField, CircularProgress } from '@mui/material'; // Using Material-UI components
import { FaEdit, FaTrash, FaPlus, FaEye } from 'react-icons/fa';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { Constants } from '../../endPoints';
import { jwtDecode } from 'jwt-decode'; // Corrected import
import Searchcategory from '../Home/HomeSearch/Searchcategory';
import "react-quill/dist/quill.snow.css";
import Breadcumb from '../../Layouts/Breadcumb'
import DashboardNav from './DashboardNav';
import Swal from 'sweetalert2';
import { useHistory } from 'react-router-dom';


const Listproduct = () => {
  const [products, setProducts] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [pagination, setPagination] = useState({
    totalItems: 0,
    totalPages: 1,
    currentPage: 1,
    pageSize: 10,
  });
  const [productImages, setProductImages] = useState({});
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  // Fetch products
  const fetchProducts = async (page = 1, keyword = '') => {
    const accessToken = localStorage.getItem('authToken');
    if (!accessToken) {
      console.error('No access token found');
      return;
    }
    const decodedToken = jwtDecode(accessToken);
    const id = decodedToken.id;
    setLoading(true);
    try {
      const limit = pagination.pageSize || 10;
      const response = await axios.get(`${Constants.listProductByVendor}/${id}?page=${page}&limit=${limit}&keyword=${keyword}`);
      if (response.status === 200) {
        setProducts(response.data.data || []);
        setPagination({
          totalItems: response.data.pagination.totalItems,
          totalPages: response.data.pagination.totalPages,
          currentPage: response.data.pagination.currentPage,
          pageSize: response.data.pagination.pageSize,
        });
      }
    } catch (error) {
      console.error('Error fetching products:', error);
    } finally {
      setLoading(false); // Set loading to false after the data is fetched
    }
  };
  useEffect(() => {
    if (products.length > 0) {
      fetchImagesForProducts(products);
    }
  }, [products]); // Ensure this only runs when products change

  const fetchImagesForProducts = async (products) => {
    const images = {};
    try {
      await Promise.all(
        products.map(async (product) => {
          try {
            const response = await axios.get(`${Constants.getProductImagesById}/${product.id}`);
  
            if (response.data.status === 1 && response.data.data.length > 0) {
              const firstImage = response.data.data[0];
              images[product.id] = firstImage;
            } else {
              // 👇 Fallback for missing image
              images[product.id] = { image: 'product_default.png' };
            }
  
          } catch (error) {
            console.error(`Error fetching image for product ${product.id}:`, error);
            // 👇 Even if request fails, set default image
            images[product.id] = { image: 'product_default.png' };
          }
        })
      );
  
      console.log('Fetched product images:', images);
      setProductImages(images);
  
    } catch (error) {
      console.error('Error fetching product images:', error);
    }
  };

  useEffect(() => {
    fetchProducts(pagination.currentPage, searchTerm);
  }, [pagination.currentPage, searchTerm]);

  const handleSort = (column) => {
    // Sorting logic
  };

  const handleDeleteProduct = async (id) => {
    try {
      const response = await axios.delete(`${Constants.deleteProduct}/${id}`);
      if (response.status === 200) {
        // Show success alert
        Swal.fire({
          title: 'Deleted!',
          text: 'The product has been deleted successfully.',
          icon: 'success',
          confirmButtonText: 'OK',
        }).then(() => {
          window.location.reload();
        });
      }
    } catch (error) {
      console.error('Error deleting product:', error);
      // Show error alert
      Swal.fire({
        title: 'Error!',
        text: 'There was an error deleting the product.',
        icon: 'error',
        confirmButtonText: 'OK',
      });
    }
  };

  const paginate = (pageNumber) => {
    if (pageNumber > 0 && pageNumber <= pagination.totalPages) {
      setPagination((prev) => ({
        ...prev,
        currentPage: pageNumber,
      }));
    }
  };

  const handleAddProduct = () => {
    history.push('/sell-product');
  };

  const handleStatusUpdate = async (id, newStatus) => {
    try {
      const response = await axios.put(`${Constants.updateProductStatus}/${id}`, {
        status: newStatus,
      });

      if (response.status === 200) {
        Swal.fire({
          title: 'Success!',
          text: 'Product status updated successfully.',
          icon: 'success',
          confirmButtonText: 'OK',
        });
        // Fetch the updated product list
        fetchProducts(pagination.currentPage, searchTerm);
      }
    } catch (error) {
      console.error('Error updating product status:', error);
      Swal.fire({
        title: 'Error!',
        text: 'There was an error updating the product status.',
        icon: 'error',
        confirmButtonText: 'OK',
      });
    }
  };

  return (
    <>
      <Breadcumb pagetitle="Listings" />
      <section className='py-12'>
        <div className='container mx-auto px-4'>
          <Grid container spacing={5}>
            <Grid item lg={3} md={12} sm={12} xs={12}>
              <DashboardNav />
            </Grid>
            <Grid item lg={9} md={12} sm={12} xs={12}>
              <div className="main-content">
                <div className="page-content">
                  <h2 class="text-3xl font-bold headningfont mb-5">My listings</h2>
                  <Grid container spacing={3}>


                    {/* Search Box */}
                    <Grid item xs={12} md={6}>
                      {/* <TextField
                        label="Search Products"
                        variant="outlined"
                        fullWidth
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                      /> */}
                    </Grid>

                    <Grid item xs={12} md={6} className='text-end'>
                      <button
                        onClick={handleAddProduct}
                        className='inline-block h-14 px-8 border rounded bg-[#b3902d] min-w-32 text-white font-semibold'>
                        Add Product
                      </button>
                    </Grid>

                    {/* Table */}
                    <Grid item xs={12}>
                      <Table className='w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400"table-auto border'>
                        <thead className='text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400"'>
                          <tr>
                            <th className='px-4 py-3' onClick={() => handleSort('id')}>Product ID</th>
                            <th className='px-4 py-3' onClick={() => handleSort('name')}>Country</th>
                            <th className='px-4 py-3'>Main Selection</th>
                            <th className='px-4 py-3'>Category</th>
                            <th className='px-4 py-3'>Shop For</th>
                            <th className='px-4 py-3'>Image</th>
                            <th className='px-4 py-3'>Status</th>
                            <th className='px-4 py-3'>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {products.map((product) => (
                            <tr key={product.id} className='odd:bg-white odd:dark:bg-gray-900 even:bg-gray-50 even:dark:bg-gray-800 border-b dark:border-gray-700'>
                              <td className="px-4 py-4">{product.id}</td>
                              <td className="px-4 py-4">{product.countryName}</td>
                              <td className="px-4 py-4">{product.selectionName}</td>
                              <td className="px-4 py-4">{product.categoryName}</td>
                              <td className="px-4 py-4">{product.shopForName}</td>
                              <td className="px-4 py-4">
                                {productImages[product.id] ? (
                                  <img
                                    src={`${Constants.imageBaseURL}${productImages[product.id].image}`} // Display the first image only
                                    alt={`Product ${product.id}`}
                                    style={{ width: '50px', height: '50px', objectFit: 'cover', marginRight: '5px' }}
                                  />
                                ) : (
                                  <span>No Image</span> // Display this if no image is available
                                )}
                              </td>
                              <td className="px-4 py-4 text-center">
                                <label className="relative inline-flex items-center cursor-pointer">
                                  <input
                                    type="checkbox"
                                    className="sr-only peer"
                                    checked={product.status === 'Active'}
                                    onChange={() => handleStatusUpdate(product.id, product.status === 'Active' ? 'Inactive' : 'Active')}
                                  />
                                  <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-blue-300 rounded-full peer dark:bg-gray-700 peer-checked:bg-green-500">
                                  </div>
                                  <span className="ml-2 text-sm font-medium text-gray-900">
                                    {product.status === 'Active' ? 'Active' : 'Inactive'}
                                  </span>
                                </label>
                              </td>


                              <td className="px-4 py-4 text-center">
                                <div className='flex gap-3 items-center'>
                                  <Link to={`/details/${product.id}`} className="text-blue-500 hover:text-blue-700 transition p-2 rounded-full hover:bg-blue-100"><FaEye /></Link>
                                  <Link to={`/edit-product/${product.id}`} className="text-green-500 hover:text-green-700 transition p-2 rounded-full hover:bg-green-100"><FaEdit /></Link>
                                  <button type='button' className="text-red-500 hover:text-red-700 transition p-2 rounded-full hover:bg-red-100" onClick={() => handleDeleteProduct(product.id)}><FaTrash /></button>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </Grid>

                    {/* Pagination */}
                    <Grid item xs={12}>
                      <div className="flex justify-center items-center space-x-2 mt-4">
                        {/* Pagination Component */}
                        <button
                          className="px-3 py-1 border border-gray-300 rounded-md hover:bg-gray-200 transition disabled:opacity-50"
                          onClick={() => paginate(pagination.currentPage - 1)}
                          disabled={pagination.currentPage <= 1}
                        >
                          Prev
                        </button>
                        {Array.from({ length: pagination.totalPages }, (_, index) => (
                          <button
                            key={index}
                            className={`px-3 py-1 border border-gray-300 rounded-md hover:bg-gray-200 transition ${pagination.currentPage === index + 1 ? 'bg-gray-300 font-bold' : ''}`}
                            onClick={() => paginate(index + 1)}
                          >
                            {index + 1}
                          </button>
                        ))}
                        <button
                          className="px-3 py-1 border border-gray-300 rounded-md hover:bg-gray-200 transition disabled:opacity-50"
                          onClick={() => paginate(pagination.currentPage + 1)}
                          disabled={pagination.currentPage >= pagination.totalPages}
                        >
                          Next
                        </button>
                      </div>
                      {loading && (
                        <div className="flex justify-center mt-4">
                          <CircularProgress />
                        </div>
                      )}
                    </Grid>



                  </Grid>
                </div>
              </div>
            </Grid>
          </Grid>
        </div>
      </section>

    </>
  );
};

export default Listproduct;
